export default __webpack_public_path__ + "static/media/report_c1f19e4b-3743-4cfd-b33d-20ab0f29b13f-hover.83bcc88c.svg";